export * from './fetch'

export const PL_PLAYER_RESET = 'PL_PLAYER_RESET'

export const playerReset = () => ({
  payload: null,
  type: PL_PLAYER_RESET,
})
